import React, { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { AREA_LABEL, switchArea, switchError } from "./membershipApi";

// Upgrade prompt for a specialist area (Golf / Gym): Core members pay £3 more a month.
export const AreaUpsell = ({ area, price = 9.99, core = 6.99, note, onDone }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await switchArea(area);
      if (r.switched) { toast.success(`Welcome to Soulumo + ${AREA_LABEL[area]}`); onDone?.(); }
    } catch (e) { toast.error(switchError(e)); }
    setBusy(false);
  };
  return (
    <div className="mx-auto max-w-md rounded-3xl border border-[#d7bb7a]/40 bg-[#141a17]/90 p-7 text-center text-[#f3ecd9] backdrop-blur-md" data-testid={`area-upsell-${area}`}>
      <Sparkles className="mx-auto text-[#d7bb7a]" size={22} />
      <h2 className="mt-3 text-3xl text-[#f3ecd9]" style={{ fontFamily: '"Cormorant Garamond", Georgia, serif' }}>Soulumo + {AREA_LABEL[area]}</h2>
      <p className="mt-3 text-sm text-[#cfc6ae]">{note || `Every ${AREA_LABEL[area]} installation, plus your ${AREA_LABEL[area]} Coach each month.`}</p>
      <p className="mt-5 text-2xl text-[#f3ecd9]" data-testid={`area-upsell-price-${area}`}>£{price.toFixed(2)}<span className="text-sm text-[#b9ad8f]"> / month</span></p>
      <p className="text-xs text-[#9fb39a]">Just £{(price - core).toFixed(2)} more than Soulumo Core</p>
      <button type="button" onClick={go} disabled={busy} data-testid={`area-upsell-btn-${area}`}
        className="mt-6 w-full rounded-full border border-[#d7bb7a] bg-[#d7bb7a]/15 py-3.5 text-xs uppercase tracking-[0.26em] transition-colors hover:bg-[#d7bb7a]/30 disabled:opacity-50">
        {busy ? <Loader2 size={14} className="mx-auto animate-spin" /> : `Upgrade for £${(price - core).toFixed(2)} more`}
      </button>
    </div>
  );
};
